import React, {Component} from "react"

import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

/**
 * selected
 * 
 * onSaveClick(name)
 * onCancelClick
 */

class EditTemplateDialog extends Component {

    constructor(props) {
        super(props)

        this.state = {
            name: this.props.selected.name,
        }
    }

    readyToCreate = () => Boolean(this.state.name)

    render() {
        return <Dialog open fullWidth>
            <DialogTitle>Изменить шаблон закупки</DialogTitle>
            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                <TextField
                    value = {this.state.name}
                    label = "Название"
                    margin = "normal"
                    onChange = {e => {
                        e.preventDefault()
                        this.setState({name: e.target.value})
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    disabled = {!this.readyToCreate()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onSaveClick === "function") {
                            let result = global.structuredClone(this.props.selected)
                            result.name = this.state.name
                            this.props.onSaveClick(result)
                        }
                    }}
                >Сохранить</Button>
                <Button
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >Отмена</Button>
            </DialogActions>
        </Dialog>
    }

}

export default EditTemplateDialog